import { Routes } from "react-router-dom";

export const ROUTE_CONSTANT = {
  VERIFY_USER: "/app/account/verify-user",
  ROOT: "/",
  ROOT_LOCALE: "/:locale",
  ROOT_HOME: "/app",
  ROOT_HOME_LOCALE: "/app/:locale/",
  HOME: "/app/account/signup",
  HOME_LOCALE: "/app/:locale/account/signup",
  BILLING_TRANSFER: "/app/billing/billing-transfer",
  BILLING_TRANSFER_LOCALE: "/app/:locale/billing/billing-transfer",
  SIGNOUT: "/app/account/signout",
  SIGNIN: "/app/account/signin",
  SIGNIN_LOCALE: "/app/:locale/account/signin",
  SIGNUP: "/app/account/signup",
  SIGNUP_LOCALE: "/app/:locale/account/signup",
  SECURE_UPLOAD: "/app/account/secure-upload",
  SECURE_UPLOAD_LOCALE: "/app/:locale/account/secure-upload",
  FORGOT_PASSWORD: "/app/account/forgot-password",
  FORGOT_PASSWORD_LOCALE: "/app/:locale/account/forgot-password",
  RESET_PASSWORD: "/app/account/reset-password",
  RESET_PASSWORD_LOCALE: "/app/:locale/account/reset-password",
  PAGE_NOT_FOUND: "/app/billing/page-not-found",
  ADMIN_DASHBOARD: "/app/admin/dashboard",
  DASHBOARD_TRANSFER: "/app/dashboard/",
  DASHBOARD_TRANSFER_LOCALE: "/app/:locale/dashboard/",
  PS_FAQ: "/support/faq",
  PS_FAQ_LOCALE: ":locale/support/faq",
  PS_CONTACT: "/support/contact",
  PS_CONTACT_LOCALE: "/:locale/support/contact",
  PS_CONTACT_EFLOW: "/support/contact",
  PS_CONTACT__EFLOW_LOCALE: "/:locale/support/contact",
  USER_ADMIN_DASHBOARD: "/app/dashboard",
  USER_ADMIN_SETTINGS: "/app/settings",
  ADMIN_DASHBOARD: "/app/admin/dashboard",
  ADMIN_SUBSCRIPTION_VIEW: "/admin/subscription/view",
  ADMIN_SUBSCRIPTION_CANCEL: "/admin/subscription/cancel",
  ADMIN_RESUME_DOWNLOAD: "/admin/resume/download",
  ADMIN_BECOME: "/admin/become",
  THANK_YOU: "/app/thank-you",
  ADMIN_LOGIN: "/app/account/admin-login",
  // BILLING_TRANSFER_LOCALE: "/app/:locale/billing-transfer",
  SIGNOUT_LOCALE: "/app/:locale/account/signout",
  SUMMARY_EDIT_LOCALE: "/app/:locale/summary/edit",
  USER_ADMIN_DASHBOARD_LOCALE: "/app/:locale/dashboard",
  USER_ADMIN_SETTINGS_LOCALE: "/app/:locale/settings",
  CHECKOUT_PAGE_LOCALE: "/app/:locale/checkout",
  CANCEL_SUBSCRIPTION_LOCALE: "/app/:locale/cancel-subscription",
  CANCEL_SUBSCRIPTION_CONFIRMATION_LOCALE: "/app/:locale/cancel-subscription-confirmation",
  ADMIN_DASHBOARD_LOCALE: "/app/:locale/admin/dashboard",
  ADMIN_SUBSCRIPTION_VIEW_LOCALE: "/:locale/admin/subscription/view",
  ADMIN_SUBSCRIPTION_CANCEL_LOCALE: "/:locale/admin/subscription/cancel",
  ADMIN_RESUME_DOWNLOAD_LOCALE: "/:locale/admin/resume/download",
  ADMIN_BECOME_LOCALE: "/:locale/admin/become",
  THANK_YOU_LOCALE: "/app/:locale/thank-you",
  RESUMES_LOCALE: "/app/:locale/resumes",
  // footer Routes
  RS_POLICY: "/privacy-policy/",
  RS_POLICY_LOCALE: "/:locale/privacy-policy/",
  RS_CONTACT: "/contact-us/",
  RS_CONTACT_LOCALE: "/:locale/contact-us/",
  RS_TERMS: "/terms-of-use/",
  RS_TERMS_LOCALE: "/:locale/terms-of-use/",
  RS_REFUND: "/how-to-cancel-resumebuild/",
  RS_REFUND_LOCALE: "/:locale/how-to-cancel-resumebuild/",
  LS_POLICY: "/privacy/",
  LS_POLICY_LOCALE: "/:locale/privacy/",
  LS_CONTACT: "/contact/",
  LS_CONTACT_LOCALE: "/:locale/contact/",
  LS_TERMS: "/terms/",
  LS_TERMS_LOCALE: "/:locale/terms/",
  LS_REFUND: "/refund-cancel/",
  LS_REFUND_LOCALE: "/:locale/refund-cancel/",
  PS_POLICY: "/support/privacy-policy/",
  PS_POLICY_LOCALE: "/:locale/support/privacy-policy/",
  PS_CONTACT: "/support/",
  PS_CONTACT_LOCALE: "/:locale/support/",
  PS_TERMS: "/support/terms-and-conditions/",
  PS_TERMS_LOCALE: "/:locale/support/terms-and-conditions/",
  PS_REFUND: "/support/refund-cancel/",
  PS_REFUND_LOCALE: "/:locale/support/refund-cancel/",
  WS_CONTACT: "/support/contact/",
  WS_CONTACT_LOCALE: "/:locale/support/contact/",
  WS_TERMS: "/terms-and-conditions/",
  WS_TERMS_LOCALE: "/:locale/terms-and-conditions/",
  WS_POLICY: "/privacy-policy/",
  WS_POLICY_LOCALE: "/:locale/privacy-policy/",
  SS_POLICY: "/privacy-policy/",
  SS_POLICY_LOCALE: "/:locale/privacy-policy/",
  SS_CONTACT: "/contact-us/",
  SS_CONTACT_LOCALE: "/:locale/contact-us/",
  SS_TERMS: "/terms-and-conditions/",
  SS_TERMS_LOCALE: "/:locale/terms-and-conditions/",
  SS_REFUND: "/refund-cancel/",
  SS_REFUND_LOCALE: "/:locale/refund-cancel/",
  SESSION_EXPIRE: "/session-expire/",
  SESSION_EXPIRE_LOCALE: "/:locale/session-expire/",
  QW_POLICY: "/privacy-policy/",
  QW_POLICY_LOCALE: "/:locale/privacy-policy/",
  QW_TERMS: "/terms-and-conditions/",
  QW_TERMS_LOCALE: "/:locale/terms-and-conditions/",
  QW_CONTACT: "/support/",
  QW_CONTACT_LOCALE: "/:locale/support/",
  SHARE: "/app/account/share",
  SHARE_LOCALE: "/app/:locale/account/share",
};